// Note: this file is temporary and will be removed on A/B test conclusion

/** Matches LESA_ESCALATION_TREATMENT_VARIATION in svc-support. */
export const LESA_ATI_REMOVAL_VARIATION = 'treatment'

export const LESA_ATI_REMOVAL_HUMAN_REQUESTED_EVENT = {
  key: 'lesa_ati_removal_human_requested',
  optimizelyEventId: '5355980819529728',
} as const

export const LESA_ATI_REMOVAL_CONTINUED_CHAT_EVENT = {
  key: 'lesa_ati_removal_continued_chat',
  optimizelyEventId: '5513882523926528',
} as const

/**
 * Pills that mean the customer acted to reach a human, in either arm. Control shows requestAgent /
 * confirmRequestAgent; treatment shows the swapped escalation pill in menus. The callback pill is
 * deliberately absent: high tier no longer offers callbacks, and that pill still appears in other
 * LESA flows that have nothing to do with this test.
 */
const ESCALATION_OFFER_ACTION_KEYS = new Set<string>([
  'requestAgent',
  'confirmRequestAgent',
  'requestSupportEscalation',
])

// The "No thank you, I want to keep speaking to you!" pill.
export function isContinueChatAction(category?: string): boolean {
  return category === 'chatLesa'
}

export function isEscalationActionKey(actionKey?: string): boolean {
  return !!actionKey && ESCALATION_OFFER_ACTION_KEYS.has(actionKey)
}
